import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { interval } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class VersionCheckService {
  private currentVersion: string | null = null;

  constructor(private http: HttpClient) {}

  public initVersionCheck() {
    this.loadCurrentVersion().then(() => {
      this.checkVersion(); // checa logo de início
      interval(5 * 60 * 1000).subscribe(() => this.checkVersion());
    });
  }

  private async loadCurrentVersion() {
    try {
      const data = await this.http
        .get<{ version: string }>('/assets/version.json', {
          headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' }
        })
        .toPromise();

      this.currentVersion = data?.version || null;
    } catch (err) {
      console.warn('Falha ao carregar versão inicial', err);
    }
  }

  private checkVersion() {
    this.http
      .get<{ version: string }>('/assets/version.json', {
        headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' }
      })
      .subscribe((data: { version: any; }) => {
        const newVersion = data.version;

        if (this.currentVersion && newVersion && newVersion !== this.currentVersion) {
          alert('Nova versão disponível. A página será recarregada.');
          location.reload();
        }
      });
  }
}
